import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import Svg from "../Svg";
const Text = ({
  height = 110,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Svg, _extends({}, props, {
    height: height
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "3",
    ry: "3",
    width: "40%",
    height: "21px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "29px",
    rx: "3",
    ry: "3",
    width: "100%",
    height: "21px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "58px",
    rx: "3",
    ry: "3",
    width: "100%",
    height: "21px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "87px",
    rx: "3",
    ry: "3",
    width: "100%",
    height: "21px"
  }));
};
export default Text;